const BlueButton = ({ text, icon, onClick , customClass }) => {
  return (
    <button className={!customClass? "blue_button"  : customClass} onClick={onClick}>
      {icon}
      {text}
    </button>
  );
};

export default BlueButton;
